export const APPLY_LICENSE_ACCOUNTS = ['zjydjc']



//////////////////
// WEBPACK FOOTER
// ./config/app.js
// module id = 10
// module chunks = 3